// extracted by mini-css-extract-plugin
module.exports = {"container":"edit_container__3mHSS"};